import React, { useState } from "react";
import { PropTypes } from "prop-types";
import UsageCircuitsCharts from "./CircuitUsageCharts";
import AdSumamryTable from "./AnomalySummaryTable";
import CellularInterfaceUsageCharts from "./CellularInterfaceUsageCharts";
import UsageADTabs from "./UsageADTabs";
import AppHoc from "../../../../../generics/AppHOC";
import * as actions from "../actions";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import useI18n from "../../../../../i18n/useI18n";

const mapStateToProps = state => {
  return {
    adKey: state.vanalytics.adKey
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

const [HbrTabGroup, HbrTab] = reactWrapper(["hbr-tab-group", "hbr-tab"]);

const ADUsageView = props => {
  const { tViews } = useI18n('views')
  const [selectedTab, setSelectedTab] = useState(
    tViews('usageBasedAD.anomalyCellularTab')
  );

  const onTabsChange = tab => {
    setSelectedTab(tab);
  };

  const renderTabs = (tabId, tab, tabAD) => {
    return (
      <>
        <HbrTab
          slot="nav"
          id={tabId}
          role="tab"
          aria-selected={selectedTab === tab}
          active={selectedTab === tab}
          key={tab}
          panel={tab}
          onHbr-active={() => onTabsChange(tab)}
        >
          <div>{tabAD}</div>
        </HbrTab>
      </>
    );
  };

  return (
    <div role="region" aria-label={tViews('anomalyDetectionUsage')}>
      <UsageCircuitsCharts
        saveUsageDateForTable={props.actions.saveUsageDateForTable}
        refresh={props.globalFilter.onAnomalyRefresh}
      />
      {props.adKey.adUsageDate && (
        <HbrTabGroup
          aria-label={
            tViews('a11yLabels.tabsGroupLabel') || tViews('a11yLabels.anomalyDetectionTabs')
          }
        >
          {renderTabs(
            "ad-tab-anomaly-cellular",
            tViews('usageBasedAD.anomalyCellularTab'),
            tViews('usageBasedAD.anomalyCellular')
          )}
          {renderTabs(
            "ad-tab-all-cellular",
            tViews('usageBasedAD.allCellularTab'),
            tViews('usageBasedAD.allCellular')
          )}
        </HbrTabGroup>
      )}
      {props.adKey.adUsageDate && (
        <AdSumamryTable
          setSelectedSite={props.setSelectedSite}
          selectedHour={props.adKey.adUsageDate}
          saveUsageCipProps={props.actions.saveUsageCipProps}
          refresh={props.globalFilter.onAnomalyRefresh}
          circuitsMasterTable={props.globalFilter.circuitsMasterTable}
          selectedTab={selectedTab}
        />
      )}
      {props.adKey.cellularInterfaceProps.circuitName &&
        props.adKey.cellularInterfaceProps.site && (
          <div>
            <UsageADTabs
              selectedHour={props.adKey.adUsageDate}
              cellularInterfaceProps={props.adKey.cellularInterfaceProps}
              circuitTrendList={props.adKey.circuitTrendList}
              isCircuitListSame={props.actions.isCircuitListSame}
              saveSelectedTrendCircuits={
                props.actions.saveSelectedTrendCircuits
              }
              selectedtrendCircuits={props.adKey.selectedtrendCircuits}
              prevCircuitUsageList={props.adKey.prevCircuitUsageList}
              isPrevUsgList={props.actions.isPrevUsgList}
              setAppUsgList={props.actions.setAppUsgList}
              appUsageList={props.adKey.appUsageList}
              setPrevAppUsgList={props.actions.setPrevAppUsgList}
              prevAppUsageList={props.adKey.prevAppUsageList}
            >
              <CellularInterfaceUsageCharts
                selectedHour={props.adKey.adUsageDate}
                cellularInterfaceProps={props.adKey.cellularInterfaceProps}
              />
            </UsageADTabs>
          </div>
        )}
    </div>
  );
};

ADUsageView.propTypes = {
  globalFilter: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  adKey: PropTypes.object.isRequired,
  setSelectedSite: PropTypes.func.isRequired
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AppHoc(ADUsageView))
);
